import React from 'react';
import {useNavigate} from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import {SvgIcon} from '../icons/svgIcon';
import {Icons} from '../icons/icons';
import {HibuUiConfig} from '../config/config-types';
import {useTranslation} from 'react-i18next';
import {useLocalizationUtil} from '../localizationUtil';

type HeaderMenuProps = {
    config: HibuUiConfig;
    isSearchPage: boolean;
    isAnalysisPage: boolean;
    isAssistantPage: boolean;
    isDocumentAssistantPage: boolean;
};

export const HeaderMenu = React.memo(({
                                          config,
                                          isSearchPage,
                                          isAnalysisPage,
                                          isAssistantPage,
                                          isDocumentAssistantPage
                                      }: HeaderMenuProps) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const navigateToAnalysisPage = () => navigate('/analysis');
    const navigateToAssistantPage = () => navigate('/assistant');
    const navigateToDocumentAssistantPage = () => navigate('/document-assistant');
    const navigateToSearchPage = () => navigate('/search');
    const navigateToPage = (url: string, openInNewTab: boolean) => {
        if (openInNewTab) {
            window.open(url, '_blank');
        } else {
            window.location.href = url;
        }
    };
    const {selectedLanguage: currentLanguage} = useLocalizationUtil();
    const isLandingPage = !isSearchPage && !isAnalysisPage && !isAssistantPage && !isDocumentAssistantPage;

    return (
        <Dropdown id="switch-pages-dropdown" title={''} className="navigation-dropdown">
            <Dropdown.Toggle className="navigation-toggle">
                <SvgIcon icon={Icons.MENU} id="icon-menu" uncolored={isLandingPage}/>
            </Dropdown.Toggle>
            <Dropdown.Menu align={'end'} className="navigation-menu">
                {config.search.enabled && (
                    <Dropdown.Item eventKey="1" active={isSearchPage} onClick={navigateToSearchPage}>
                        {t('navigation.search')}
                    </Dropdown.Item>
                )}
                {config.analysis.enabled && (
                    <Dropdown.Item eventKey="2" active={isAnalysisPage} onClick={navigateToAnalysisPage}>
                        {t('navigation.analysis')}
                    </Dropdown.Item>
                )}
                {config.aiAssistant?.globalAssistant.enabled &&
                    <Dropdown.Item eventKey="3" active={isAssistantPage} onClick={navigateToAssistantPage}>
                        {t('navigation.assistant')}
                    </Dropdown.Item>
                }
                {config.aiAssistant?.allDocsAssistant.enabled &&
                    <Dropdown.Item eventKey="4" active={isDocumentAssistantPage}
                                   onClick={navigateToDocumentAssistantPage}>
                        {t('navigation.document-assistant')}
                    </Dropdown.Item>
                }
                {config.menuItems?.length > 0 && (
                    <>
                        <Dropdown.Divider/>
                        {config.menuItems.map((menuItem) => (
                            <Dropdown.Item key={menuItem.name}
                                           onClick={() => navigateToPage(menuItem.link, menuItem.openInNewTab)}>
                                {menuItem.translations?.[currentLanguage] ?? menuItem.name}
                            </Dropdown.Item>
                        ))}
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
});
